module.exports = __webpack_public_path__ + "media/images/front/icon_favorite_off-8eda9cf47849e43c4862f095852f7e3b.png";